var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrainline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.5C8 1.94772 8.44772 1.5 9 1.5H15C15.5523 1.5 16 1.94772 16 2.5V3H17C18.6569 3 20 4.34315 20 6V14.5C20 16.9853 17.9853 19 15.5 19H8.5C6.01472 19 4 16.9853 4 14.5V6C4 4.34315 5.34315 3 7 3H8V2.5ZM7 5C6.44772 5 6 5.44772 6 6V10H11V5H7ZM18 6V10H13V5H17C17.5523 5 18 5.44772 18 6ZM8.5 16C9.32843 16 10 15.3284 10 14.5C10 13.6716 9.32843 13 8.5 13C7.67157 13 7 13.6716 7 14.5C7 15.3284 7.67157 16 8.5 16ZM17 14.5C17 15.3284 16.3284 16 15.5 16C14.6716 16 14 15.3284 14 14.5C14 13.6716 14.6716 13 15.5 13C16.3284 13 17 13.6716 17 14.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 20H17L18 21V22H6V21L7 20Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainline);
export default __webpack_public_path__ + "static/media/trainline.097c47f1ba2d9ede56b52c9ae456e2d9.svg";
export { ForwardRef as ReactComponent };